'use strict';

/**
 * @ngdoc component
 * @name mx.shell:mxShellNavDropdownLevel
 * @module mx.shell
 * @description Shows Navigation Level as Dropdown (used for 4+ level(s))
 * @param {string} triggeringIcon@ - icon to open dropdown. If it is not defined, then `parentNavItem.title` will be used
 * @param {object} parentNavItem= - parent Navigation Item
 */

import template from './mx-shell-nav-dropdown-level.html';

export const mxShellNavDropdownLevelComponent = {
	bindings: {
		parentNavItem: '<',
		triggeringIcon: '@',
	},
	controller: MxShellNavDropdownLevelCtrl,
	controllerAs: 'vm',
	template,
};

MxShellNavDropdownLevelCtrl.$inject = ['$element', 'mx.shell.EventService', 'mx.shell.NavigationService'];

function MxShellNavDropdownLevelCtrl($element, eventService, navigationService) {
	const vm = this;

	vm.$onInit = async function () {
		const parentChildren = vm.parentNavItem.children || [];
		await Promise.all(parentChildren.map((childItem) => navigationService.loadChildren(childItem)));
		vm.dropdownNavItems = parentChildren;
	};

	vm.$postLink = function () {
		// ARIA optimization: allows to detect wrong possible focus position
		// similar to this: https://github.com/angular/material/issues/10075
		vm.isInsideDummyTab = !!$element.closest('md-dummy-tab').length;
	};

	vm.handleOpenButtonKeypress = ($event) => {
		$event.stopPropagation();
		if ($event.which === 13 || $event.which === 32) {
			$($event.target).click();
		}
	};

	vm.handleItemClick = ($event, item) => {
		if (item.current) {
			return false;
		}
		eventService.dispatchEvent(mx.shell.EventCodes.TrackTelemetry, { eventName: `Navigation clicked`, sender: item.id, senderTitle: item.technicalName });

		let itemToBeOpen = item;
		while (!itemToBeOpen.route && itemToBeOpen.children?.length) {
			itemToBeOpen = itemToBeOpen.children[0];
		}

		navigationService
			.setCurrentNavigationItem(itemToBeOpen)
			.then(() => {
				eventService.dispatchEvent(mx.shell.EventCodes.NavigationItemClicked, { navigationItem: itemToBeOpen, $event });
			})
			.catch(mx.logCatch);

		cleanUpDropdowns();
	};

	function cleanUpDropdowns() {
		setTimeout(() => {
			$('.md-open-menu-container:has(.mx-shell-nav-dropdown-level--container):visible').hide();
		}, 200);
	}
}
